module.exports = __webpack_public_path__ + "35fb99a6bf068cad9ab5923ef06934dd.jpg";